// Pertenencia de plantillas a secciones (Ajustes > Plantillas). Cada
// plantilla hidratada trae placements: [{ section_id, position }], una
// entrada por sección en la que está; la misma plantilla puede estar en
// varias secciones a la vez.

export const placementIn = (template, sectionId) =>
  (template.placements || []).find(p => p.section_id === sectionId);

export const isUnclassified = template => !(template.placements || []).length;

// Plantillas de una sección ordenadas por su posición dentro de ella
// (sectionId null = sin clasificar, ordenadas por nombre).
export const templatesInSection = (templates, sectionId) => {
  if (!sectionId) {
    return templates
      .filter(isUnclassified)
      .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
  }
  return templates
    .filter(t => placementIn(t, sectionId))
    .sort(
      (a, b) =>
        (placementIn(a, sectionId).position || 0) -
        (placementIn(b, sectionId).position || 0)
    );
};
